import { render, staticRenderFns } from "./callCenter.vue?vue&type=template&id=137ea549&scoped=true"
import script from "./callCenter.vue?vue&type=script&lang=js"
export * from "./callCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ea549",
  null
  
)

export default component.exports